import React from 'react';
import PropTypes from 'prop-types';

import {Field} from 'redux-form';
import FieldText from '../../fields/fieldText/FieldText';

export default function ConstructedTextAreaField({field}) {
  return (
    <Field
      name={field.code}
      label={`${field.name} ${field.required ? '*' : ''}`}
      required={field.required}
      type="textarea"
      component={FieldText}
    />
  );
}



// WEBPACK FOOTER //
// ./components/constructedForm/fields/ConstructedTextAreaField.js